<template>
<!-- UTILIZADO POR COMPONENTES: ARTICULOS.VUE & MODIFICARPROYECTO.VUE -->
  <div>
    <div v-if="!archivo">
      <v-btn class="success darken-1 mx-2" small text @click="mostrarModal = true">
        Excel
      </v-btn>
    </div>

    <div v-else>
      <v-btn class="blue-grey darken-3 mx-2" dark small text @click="mostrarModal = true">
        Modificar
      </v-btn>
    </div>

    <v-dialog v-model="mostrarModal" max-width="600px" persistent>
      <v-card>
        <v-card-title> Ingresar Archivo excel </v-card-title>
        <v-card-text>
          <v-file-input v-model="archivo"  outlined accept=".xls,.xlsx">
            <template v-slot:selection="{ text }">
              <v-chip small label color="primary">
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
          <div class="d-flex justify-space-around">
            <v-btn class="grey darken-2 white--text" small text @click="()=>{archivo=null, mostrarModal = false}">
              Cancelar
            </v-btn>
            <v-btn
              @click="seleccionarArchivo(archivo)"
              small
              text
              class="success darken-1"
            >
              Aceptar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mostrarModal: false,

      archivo: null,
    };
  },

  computed: {},

  methods: {
    seleccionarArchivo(archivo) {
      this.archivo = archivo;
      this.$emit("EXCEL", archivo);
      this.archivoSubido = true;
      this.mostrarModal = false;
    },

    log() {
      console.log(this.archivo);
    },
  },
};
</script>

<style></style>
